import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { urlConfig } from '../../config/urlConfig';
import { Button } from '@material-ui/core';
import { FaFacebook } from 'react-icons/fa';
import { makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import Cookies from 'js-cookie';
import { ProfileContext } from '../../services/profile/profile.context';
import {
  accessTokenRequest,
  sendRequest,
} from '../../services/global/global.service';

const useStyle = makeStyles((theme) => {
  return {
    facebookIcon: {
      color: '#3b5998',
    },
    Button: {
      display: 'flex',
      justifyContent: 'start',
      marginTop: 16,
    },
  };
});

export function ConnectAccountFacebook({ setError }) {
  const classes = useStyle();
  const [loading, setLoading] = useState(false);
  const [isConnect, setIsConnect] = useState(false);
  const { user, checkIsConnect } = useContext(ProfileContext);

  useEffect(() => {
    const userData = {
      provider: 'facebook',
      user_uuid: user && user.uid,
    };

    user && user.uid && checkIsConnect(setLoading, setIsConnect, userData);
  }, [user]);

  const disconnectFacebook = () => {
    setLoading(true);

    const userData = {
      user_uuid: user.uid,
      provider: 'facebook',
    };

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.disconnect, response, 'post', userData)
          .then((res) => {
            setIsConnect(false);
            setLoading(false);
            setError('');
          })
          .catch((e) => {
            setLoading(false);
            setError(e.toString());
          });
      })
      .catch((e) => {
        setLoading(false);
        setError(e.toString());
      });
  };

  const responseFacebook = (response) => {
    setLoading(true);
    let resEmail = response.email;
    let hostEmail = user.email;

    if (hostEmail !== resEmail) {
      axios
        .post(urlConfig.login_with_facebook, {
          access_token: response.accessToken,
        })
        .then((res) => {
          axios
            .post(urlConfig.connect_account, {
              uid: response.id,
              user_uuid: user.uid,
              email: response.email,
              provider: 'facebook',
            })
            .then((result) => {
              setIsConnect(true);
              setLoading(false);
              setError('');
            })
            .catch((err) => {
              setIsConnect(false);
              setLoading(false);
              setError(err.toString());
              console.log(err);
            });
        })
        .catch((err) => {
          setError(err.toString());
          console.log(err);
          setLoading(false);
        });
    } else {
      axios
        .post(urlConfig.connect_account, {
          uid: response.id,
          user_uuid: user.uid,
          email: response.email,
          provider: 'facebook',
        })
        .then((result) => {
          setIsConnect(true);
          setLoading(false);
          setError('');
        })
        .catch((err) => {
          setIsConnect(false);
          setError(err.toString());
          setLoading(false);
        });
    }
  };

  return (
    <FacebookLogin
      appId='899740784279900'
      fields='name,email'
      permissions={['email']}
      callback={responseFacebook}
      icon='fa-facebook'
      render={(renderProps) => (
        <Button
          disabled={loading}
          onClick={isConnect ? disconnectFacebook : renderProps.onClick}
          className={classes.Button}
          variant='outlined'
          startIcon={<FaFacebook className={classes.facebookIcon} />}
        >
          {isConnect ? 'Disconnect Facebook' : 'Connect Facebook'}
        </Button>
      )}
    />
  );
}
